module.exports = __webpack_public_path__ + "static/media/imagem26.967ba242.jpeg";